import { Grid } from '@material-ui/core'
import { useEffect } from 'react'
import { Button, useRefresh, useTranslate } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'

export const CreateSiblingButton = ({
  setOpenResolutionId,
  setIsChanged,
  setOpen,
  ...props
}) => {
  const { record } = props
  const classes = useStyles()
  const translate = useTranslate()
  const refresh = () => {
    setIsChanged((prev) => {
      let newVal = new Date().getTime()
      return newVal
    })
  }
  if (record.parent_id === null) return null

  const create = () => {
    Api.resolutions
      .update(record.id, { ...record, createopensibling: true })
      .then(({ data }) => {
        setOpen(false)
        setOpenResolutionId(data.id)
        refresh()
      })
      .catch((error) => {})
  }
  return (
    <Grid item xs={12}>
      <Button
        className={classes.actionButton}
        variant="contained"
        size="normal"
        color="secondary"
        label={translate('hs.ags.create_subresolution_sibling')}
        onClick={create}
      />
    </Grid>
  )
}
export default CreateSiblingButton
